export default __webpack_public_path__ + "static/media/segre18.1ae7e7fc.jpg";